const display = function display(label1) {
  let label2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return label1 ? "<br>".concat(label2, " ").concat(label1) : '';
};

export const capitalize = name => name && "".concat(name[0].toUpperCase() + name.slice(1).toLowerCase());
export const formatAddress = (_ref) => {
  let {
    address,
    address2,
    zipcode,
    city,
    countryLabel,
    phone,
    company,
    comment
  } = _ref;
  return "\n  ".concat(address, "\n  ").concat(display(address2), "\n  ").concat(display(city, zipcode), "\n  ").concat(display(countryLabel), "\n  ").concat(display(phone), "\n  ").concat(display(company), "\n  ").concat(display(comment), "\n");
};
export const formatUserName = function formatUserName() {
  let civility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let firstname = arguments.length > 1 ? arguments[1] : undefined;
  let lastname = arguments.length > 2 ? arguments[2] : undefined;
  return "".concat(civility, " ").concat(capitalize(firstname), " ").concat(capitalize(lastname));
};
export const getStepperColorByShipmentStatus = label => {
  const orangeStatus = ['REQUESTING_PAYEMENT', 'APOINTEMENT'];
  const redStatus = ['CANCELED'];

  if (orangeStatus.includes(label)) {
    return 'hsl(25, 70%, 53%)';
  }

  if (redStatus.includes(label)) {
    return 'hsl(3, 61%, 46%)';
  }

  return 'hsl(84, 57%, 47%)';
};